import React, { useContext, useEffect, useState } from "react";
import "../../assets/styles/order-skirts.scss";
import { Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { COLOR_PRIMARY } from "../../constants/colors";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import { Tree } from "@minoru/react-dnd-treeview";
import OrderSkirtItem from "./parts/OrderSkirtItem";
import { StoreContext } from "../../store/StoreContext";
import { saveSkirts } from "../../api/skirts";
import { toast } from "../../helpers/smu-alerts/smu-lerts";
import { preparePath } from "../../helpers";
import _ from "lodash";
import Placeholder from "./parts/Placeholder";
import Swal from "sweetalert2";

const SkirtsAdmin = () => {
  const { skirts, setSkirts } = useContext(StoreContext);

  const [sectionName, setSectionName] = useState("");
  const [sectionAbb, setSectionAbb] = useState("");
  const [skirtId, setSkirtId] = useState(null);
  const [treeData, setTreeData] = useState([]);
  const [skirtParent, setSkirtParent] = useState(null);

  useEffect(() => {
    let _skirts = skirts.map((skirt) => {
      skirt = { ...skirt, droppable: true };
      if (skirt.parent === 3) skirt.parent = 0;
      return skirt;
    });
    setTreeData(_skirts);
  }, [skirts]);

  const makeCode = (_skitrs, _skirt, code) => {
    let _code = code;
    const parent = _skitrs.find((sk) => sk.id === _skirt.parent);
    if (parent) {
      const _abb = parent?.abb || "";
      _code = _abb + "-" + _code;
      return makeCode(_skitrs, parent, _code);
    } else {
      return _code;
    }
  };

  const handleMakeCode = (_skirts) => {
    return _skirts.map((sk) => {
      const _abb = sk?.abb || "";
      const _code = makeCode(_skirts, sk, _abb);
      sk["code"] = _code;
      return sk;
    });
  };

  const createSection = (event) => {
    event.preventDefault();
    let _skirt = null;
    let newSkirts = [...skirts];
    const abb = sectionAbb.toUpperCase();

    if (!!skirtId) {
      newSkirts = newSkirts.map((s) => {
        if (Number(s.id) === Number(skirtId))
          s = { ...s, title: sectionName, abb };
        return s;
      });
    } else {
      const __skirt = _.maxBy(skirts, "id");
      const newId = (__skirt?.id || 0) + 1000 + 1;
      _skirt = {
        id: newId,
        parent: skirtParent?.id || 0,
        title: sectionName,
        abb,
        path: preparePath("/" + sectionName),
      };
      newSkirts.push(_skirt);
    }

    newSkirts = handleMakeCode(newSkirts);
    setSkirts(newSkirts);
    setSectionName("");
    setSectionAbb("");
    setSkirtId(null);

    saveSkirts(newSkirts)
      .then(({ error }) => {
        if (!!error) throw new Error(error?.message);
        toast({ icon: "success", title: "Menu faldon guardado." });
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      });
  };

  const handleDrop = (newSkirts) => {
    const _skirts = handleMakeCode(newSkirts);

    setSkirts(_skirts);
    saveSkirts(_skirts)
      .then(({ error }) => {
        if (!!error) throw new Error(error?.message);
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      });
  };

  const handleDelete = (id) => {

    let selectedMenu = skirts.filter((s) => Number(s.id) == Number(id));
    Swal.fire({
      title: `¿Deseas eliminar ${selectedMenu[0].title} del menu?`,
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      confirmButtonColor: COLOR_PRIMARY,
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (!result.isConfirmed) return;

      const newSkirts = skirts.filter((s) => Number(s.id) !== Number(id));

      setSkirts(newSkirts);
      saveSkirts(newSkirts)
      .then(({ error }) => {
        if (!!error) throw new Error(error?.message);
        toast({ icon: "success", title: "Menu faldon eliminado." });
      })
      .catch((err) => {
        console.error(err);//toast({ icon: "error", title: err });
      });
    });
  };

  const handleToEdit = (skirt) => {
    setSkirtId(skirt.id);
    setSectionName(skirt.title);
    setSectionAbb(skirt?.abb || "");
  };

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex align-items-center py-4">
        <div className="d-flex align-items-center">
          <SmuBadge color={COLOR_PRIMARY} />
          <span className="fs-5 ms-3 me-auto">Administrar menú faldones</span>
        </div>
        <button
          type="button"
          className="smu-generic-button solid-btn py-1 px-2 ms-auto"
        >
          Guardar menú
        </button>
      </Card.Header>

      <Card.Body>
        <Form
          className="smu-form pb-5"
          onSubmit={(event) => createSection(event)}
        >
          <Row className="d-flex justify-content-center">
            <Form.Group className="col-5">
              <InputGroup hasValidation>
                <Form.Control
                  type="text"
                  className="text-dark"
                  placeholder="Nombre sección"
                  value={sectionName}
                  onChange={({ target }) => setSectionName(target.value)}
                  required
                />
              </InputGroup>
            </Form.Group>
            <Form.Group className="col-2">
              <InputGroup hasValidation>
                <Form.Control
                  type="text"
                  className="text-dark text-uppercase"
                  placeholder="Código"
                  maxLength={3}
                  minLength={3}
                  value={sectionAbb}
                  onChange={({ target }) => setSectionAbb(target.value)}
                  required
                />
              </InputGroup>
            </Form.Group>
            <Col col={12} className="col-2">
              <button
                type="submit"
                className="smu-generic-button text-truncate px-2 h-100"
              >
                {skirtId ? "Guardar sección" : "Crear sección"}
              </button>
            </Col>
          </Row>
        </Form>

        <div className="h6 mb-4">Ordenar Menú</div>

        <Row>
          <Col col={12} lg={10} className="offset-lg-1">
            <Tree
              tree={treeData}
              rootId={0}
              onDrop={handleDrop}
              classes={{
                root: "skirt-list",
                draggingSource: "draggingSource",
                dropTarget: "dropTarget",
              }}
              render={(node, props) => (
                <OrderSkirtItem
                  node={node}
                  {...props}
                  _delete={handleDelete}
                  _edit={handleToEdit}
                  _click={() =>
                    setSkirtParent((prev) =>
                      prev?.id !== node.id ? node : null
                    )
                  }
                  active={skirtParent?.id === node.id}
                />
              )}
              sort={false}
              insertDroppableFirst={false}
              canDrop={(tree, { dragSource, dropTargetId, dropTarget }) => {
                if (dragSource?.parent === dropTargetId) {
                  return true;
                }
              }}
              dropTargetOffset={5}
              placeholderRender={(node, { depth }) => (
                <Placeholder depth={depth} />
              )}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default SkirtsAdmin;
